export default "__VITE_ASSET__CbiPKyI7__"